import { render, staticRenderFns } from "./denied-page.vue?vue&type=template&id=b6230c4c&"
import script from "./denied-page.vue?vue&type=script&lang=js&"
export * from "./denied-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports